const actionsType = {
    SEARCHFIELD: 'searchfield',
    GET_CONFIG: 'getConfig',
    UPDATE_CONFIG: 'updateConfig'
}

const mutationsType = {
    SET_DRAWER: 'setDrawer',
    SET_IMAGE: 'setImage',
    SET_COLOR: 'setColor',
    TOGGLE_DRAWER: 'toggleDrawer'
}

const stateType = {
    DRAWER: 'drawer',
    COLOR: 'color',    
    IMAGE: 'image',
    DEFAULT_IMAGE: 'defaultImage',
    LOGO: 'logo'    
}

export {actionsType, mutationsType, stateType };